export class ActvCpn {
    constructor({ tipoFrmEmpresa } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;

        this.model = {
            direccion: {
                value: '',
                header: 'Calle Principal No. y Calle Secundaria:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Calle/Avda. principal:',
                    FRM_DIFARE: 'Calle/Avda. principal, número y transversal:',
                },
                required: 'Dirección domicilio es requerido',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4
            },
            direccion_numero: {
                value: '',
                header: 'Número:',
                required: 'Número es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 1 caracteres',
                max: 50,
                min: 1
            },
            direccion_transversal: {
                value: '',
                header: 'Y transversal:',
                required: 'Calle transversal es requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4
            },
            pais_dd: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia_dd: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad_dd: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton_dd: {
                value: '',
                header: 'Ciudad',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerido',
            },
            codigo_postal: {
                value: '',
                header: 'Apartado postal: ( en caso de residir en el extranjero)',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Apartado postal es requerido',
            },
            telefono_domicilio: {
                value: '',
                header: 'Teléfono domicilio:',
                required: 'No. de teléfono del domicilio es requerido',
                maxLength: 'Máximo 30 caracteres',
                minLength: 'Mínimo 7 caracteres',
                max: 30,
                min: 7,
            },
            telefono_celular: {
                value: '',
                header: 'No. Celular:',
                required: 'No. Celular es requerido',
                maxLength: 'Máximo 30 caracteres',
                minLength: 'Mínimo 7 caracteres',
                max: 30,
                min: 7,
            },
            email: {
                value: '',
                header: 'Correo electrónico personal:',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Correo electrónico es requerido',
            },
            situacion_laboral: {
                value: null,
                header: 'Situación laboral:',
                required: 'Tipo de formulario es requerido'
            },
            detalle_sl: {
                value: '',
                header: 'Detalle:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: false,
            },
            lugar_trabajo: {
                value: '',
                header: 'Nombre del lugar de trabajo/negocio propio:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Nombre del lugar de trabajo:',
                },
                required: 'Nombre es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            cargo: {
                value: '',
                header: 'Cargo:',
                required: 'Cargo es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            ruc: {
                value: '',
                header: 'Número de RUC en el caso de tener negocio propio:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Número de RUC( en el caso de que aplique):',
                },
                required: false,
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            tiempo_trabaja: {
                value: '',
                header: 'Tiempo que labora en el lugar de trabajo/negocio propio. Ejemplo: 2 años y 10 meses:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Tiempo que labora en el lugar de trabajo:',
                },
                required: 'Tiempo es requerido',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
            },
            actividad_economica: {
                value: null,
                header: 'Actividad económica de la entidad donde labora o negocio propio:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Actividad económica de la entidad donde labora:',
                },
                required: 'Actividad económica es requerida'
            },
            direccion_trabajo: {
                value: '',
                header: 'Dirección completa de lugar de trabajo:',
                required: 'Dirección es requerido',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
            },
            pais_ae: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia_ae: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad_ae: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerido'
            },
            canton_ae: {
                value: '',
                header: 'Ciudad',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerido'
            },
            ingreso_mensual: {
                value: 0,
                header: 'Ingreso Mensual:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Ingreso Mensual Individual/Familiar:',
                },
                required: 'Ingreso Mensual en Relación de dependencia es requerido'
            },
            egreso_mensual: {
                value: 0,
                header: 'Egreso Mensual:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Egreso Mensual Individual/Familiar:',
                },
                required: 'Egreso Mensual es requerido'
            },
            otro_ingreso_mes: {
                value: 0,
                header: 'Otros Ingresos mensuales del declarante USD:',
                required: 'Otro ingreso Mensual es requerido'
            },
            detalle_otro_ingreso: {
                value: '',
                header: 'Especifique su fuente:',
                required: false
            },
            telefono_trabajo: {
                value: '',
                header: 'Teléfono laboral:',
                required: 'Teléfono es requerido',
                maxLength: 'Máximo 30 caracteres',
                minLength: 'Mínimo 7 caracteres',
                max: 30,
                min: 7,
            },
            email_trabajo: {
                value: '',
                header: 'Correo electrónico laboral:',
                required: 'Correo electrónico es requerido'
            },
        }

        // Si es TOYOTA, el teléfono de trabajo es opcional y permite "N/A"
        if (tipoFrmEmpresa === 'FRM_TOYOTA') {
            this.model.telefono_trabajo.required = 'Teléfono laboral es requerido (coloque N/A si no aplica)';
            this.model.telefono_trabajo.min = 3;
            this.model.telefono_trabajo.minLength = 'Mínimo 3 caracteres (ej: N/A)';
        }

        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
}
